
import React, { Component } from 'react';
import { Layout } from 'antd';
import { Route } from 'react-router-dom';

// Components
import HeaderTheme from './components/header';
import SidebarTheme from './components/sidebar';

// Self Serive
import Profile from './pages/profile';
// Company
import Company from './pages/company';
// Department
import Department from './pages/department';
// Designation
import Designation from './pages/designation';
// Employee
import Employee from './pages/employee';
import EmployeeEdit from './pages/employee.edit';
// Leave
import LeaveType from './pages/leave_type';
// Holidays
import Holidays from './pages/holidays';
// Leave Track
import Leave from './pages/leave';
// Approvals
import Approvals from './pages/approvals';
// Permission
import Permission from './pages/permissions';
// Reports
import Reports from './pages/reports';
// Meetings
import Meetings from './pages/meetings';

// Prints
import ProfilePrint from './pages/prints/profile';
import AssetPrint from './pages/prints/asset';
import TravelPrint from './pages/prints/travel';
import LetterPrint from './pages/prints/letter';
import ExpCertificate from './pages/prints/expcertificate'
import ExitInterview from './pages/prints/exitinterview';
import PaySlip from './pages/prints/payslip';
import DvSaleryCertificate from './pages/prints/dv-salary-certificate';
import DvSaleryTransCertificate from './pages/prints/dv-salary-trans-certificate';
import RecommendationLetter from './pages/prints/dv-recommendation-letter';
import UndertakingLetter from './pages/prints/dv-undertaking-letter';
import DvSaleryCertificateAccount from './pages/prints/dv-salary-certificate-acc';
import EmploymentCertificate from './pages/prints/dv-employment-certificate';

// Assets
import Assets from './pages/assets';

import Travel from './pages/travel';
import NewTravel from './pages/travel/childs/new.travel';
import EditTravel from './pages/travel/childs/edit.travel';

import LeavesSummary from './pages/leaves_admin';

import CompassionateLeave from './pages/compassionate_leaves';

// Resignation
import Resignation from './pages/resignation';

import CheckList from './pages/check_list';

import RequestLetter from './pages/requests/letter';

import OnBoarding from './pages/requests/onboarding';

// Reports
import MeetingReports from './pages/hr-reports/meetings';
import ExpenseReports from './pages/hr-reports/expense';

// Request Leaves
import RequestLeaves from './pages/requests/leave/new';
import RequestLeavesEdit from './pages/requests/leave/edit';

// Expense
import Expense from './pages/expense';

// 
import IndvCarryForward from './pages/individual_carry_forwards';

const { Content } = Layout;

class App extends Component {
  
  constructor( props ) {
    super( props );

    this.state = { 
        collapsed: false,
    }

  }

  componentDidMount() {

    if( localStorage.getItem( 'menu_collapse' ) ){

      let temp_collapsed = localStorage.getItem( 'menu_collapse' );

      this.setState({ collapsed: JSON.parse( temp_collapsed ) });
      
      return false;

    }  else {
      
      localStorage.setItem( 'menu_collapse', false );
    
    }

  }

  toggle = () => { 
    this.setState({ collapsed: !this.state.collapsed });
    localStorage.setItem( 'menu_collapse', !this.state.collapsed );
  }

  render() {
    return (
      <Layout>

        <SidebarTheme path={ this.props.location.pathname } onToggle={ this.state.collapsed } />

        <Layout>

          <HeaderTheme collapsed={ this.state.collapsed } onToggle={ this.toggle } />

          <Content className="theme-content">
                         
            { /* Self Service  */ }
            <Route exact path="/" component={ ( props ) => <Profile />  } />

            { /* Company  */ }
            <Route exact path="/organization/companyprofile/" component={ ( props ) => <Company /> } />

            { /* Department  */ }
            <Route exact path="/organization/department/" component={ Department } />

            { /* Designation */ }
            <Route exact path="/organization/designation/" component={ Designation} />

            { /* Employee */ }
            <Route exact path="/organization/employees/" component={ Employee } />

            { /* Employee Edit */ }
            <Route exact path="/organization/employees/:id" component={ EmployeeEdit } />

            { /* leave */  }
            <Route exact path="/organization/leavetype/" component={ LeaveType } />

            {/* leaves Summary */}
            <Route exact path="/organization/leaves/" component={ LeavesSummary } />

            { /* Holidays */ }
            <Route exact path="/organization/holidays/" component={ Holidays } />

            { /* Permissions */ }
            <Route exact path="/organization/permissions" component={ Permission } />

            {/* Assets */}
            <Route exact path="/organization/assets" component={ Assets } />

            {/*  */}
            <Route exact path="/organization/carryforward" component={ IndvCarryForward }/>
            
            { /* Leaves */ }
            <Route exact path="/leavetrack/:cp?" component={ Leave } />
            
            { /* Approvals */ }
            <Route exact path="/approvals/:id?/:ap?" component={ Approvals } />

            { /* Meetings */ }
            <Route exact path="/meetings" component={ Meetings } />

            {/* Expense */}
            <Route exact path="/expense" component={ Expense } />

            { /* Prints */ }
            <Route exact path="/prints/profile/:id" component={ ProfilePrint } />

            <Route exact path="/prints/asset/:id" component={ AssetPrint } />
            
            <Route exact path="/prints/travel/:id" component={ TravelPrint } />

            <Route exact path="/prints/letter/:id" component={ LetterPrint } />

            <Route exact path="/prints/expcertificate/:id" component={ ExpCertificate } />

            <Route exact path="/prints/exitinterview/:id" component={ ExitInterview } />
            
            <Route exact path="/prints/payslip/:id" component={ PaySlip } />

            <Route exact path="/prints/dv-salary-certificate/:id" component={ DvSaleryCertificate } />

            <Route exact path="/prints/dv-salary-trans-certificate/:id" component={ DvSaleryTransCertificate } />

            <Route exact path="/prints/recommendation-letter/:id" component={ RecommendationLetter } />

            <Route exact path="/prints/undertaking-letter/:id" component={ UndertakingLetter } />

            <Route exact path="/prints/dv-salary-certificate-acc/:id" component={ DvSaleryCertificateAccount } />

            <Route exact path="/prints/dv-employment-certificate/:id" component={ EmploymentCertificate } />

            {/* End */}

            <Route exact path="/travel" component={ Travel } />
            
            <Route exact path="/travel/new/" component={ NewTravel } />
            
            <Route exact path="/travel/edit/:id" component={ EditTravel } />

            <Route exact path="/compassionate" component={ CompassionateLeave } />

            <Route exact path="/requests/resignation/:id?" component={ Resignation } />
            
            <Route exact path="/requests/letter/:id?" component={ RequestLetter } />
            
            <Route exact path="/requests/onboarding/:id?" component={ OnBoarding } />

            <Route exact path="/requests/new/leave" component={ RequestLeaves } />
            <Route exact path="/requests/edit/leave/:id" component={ RequestLeavesEdit } />

            <Route exact path="/settings/checklist" component={ CheckList } />

            {/* Reports */}
            
            <Route exact path="/reports" component={ Reports } />

            <Route exact path="/hr-reports/meetings/:start_date?/:end_date?/:user?" component={ MeetingReports } />

            <Route exact path="/hr-reports/expense/:start_date?/:end_date?/:user?" component={ ExpenseReports } />

            {/*  */}

          </Content>

        </Layout>

      </Layout>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js